import Vue from 'vue'
import fontawesome from '@fortawesome/fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCoffee } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'


// import { } from '@fortawesome/fontawesome-free-regular/shakable.es'

import {
  faUser, faIndent, faLock, faList, faSignOutAlt, faCog, faMapMarkerAlt, faPhone, faEnvelope, faCalendarAlt, faTicketAlt, faClipboardList, faUsers, faMoneyBill, faCalendarCheck, faTag, faFolderOpen, faSyncAlt, faArrowAltCircleLeft, faAlignJustify, faTimes, faHistory, faLink, faUserCircle, faClock
} from '@fortawesome/fontawesome-free-solid/shakable.es'

import {
  faGithub,
} from '@fortawesome/fontawesome-free-brands/shakable.es'

library.add(
  faUser, faIndent, faLock, faList, faSignOutAlt, faCog, faGithub, faMapMarkerAlt, faPhone, faEnvelope, faCalendarAlt, faTicketAlt, faClipboardList, faUsers, faMoneyBill, faCalendarCheck, faTag, faFolderOpen, faSyncAlt, faArrowAltCircleLeft, faAlignJustify, faTimes, faHistory, faLink, faUserCircle, faClock
)

Vue.component('fa', FontAwesomeIcon)
Vue.config.productionTip = false







// WEBPACK FOOTER //
// ./resources/assets/js/plugins/fontawesome.js